<template>
    <div class="zhwyjgp">
        <!-- zhwyjgp -->
    </div>
</template>
  
<script>
import { mapState } from 'vuex';

export default {
    name: 'zhwyjgp',
    computed: {
        ...mapState(['token']),
    },
    created() {
        // let timeStamp = new Date().getTime();

        if (process.env.NODE_ENV === 'development') {
            window.open(
                'https://house-web-test.zjj.sz.gov.cn/bimwygl/supervise/index.html?#/transfer?code=' + this.token
            );
        } else if (process.env.NODE_ENV === 'production') {
            window.open(
                'https://house-web.zjj.sz.gov.cn/bimwygl/supervise/index.html?#/transfer?code=' + this.token
            );
        }

        this.$router.go(-1);
    },
};
</script>
  
<style>
</style>
